import React, { useState } from 'react';

import mainImage from './../images/Service/main-image.png';
import websiteCapabilities from './../images/Service/website-capabilities.png';
import tatadigitalTech from './../images/Service/tata-digital.png';
import johnsonRoot from './../images/Service/johnson-root.png';
import config from './../images/Utils/config.png';

import amazon from './../images/Service/Brands/amazon.png';
import facebook from './../images/Service/Brands/facebook.png';
import pepsico from './../images/Service/Brands/pepsico.png';
import spendflo from './../images/Service/Brands/spendflo.png';
import tatadigital from './../images/Service/Brands/tatadigital.png';
import youtube from './../images/Service/Brands/youtube.png';

function Service() {

	const [currentQuestion, setCurrentQuestion] = useState('question1');

	function onQuestionItemClicked(id) {

		let questionItem = document.getElementById(id);
		let answer = questionItem.getElementsByClassName("answer")[0];
		let currentQuestionItem = document.getElementById(currentQuestion);
		let currentAnswer = currentQuestionItem?.getElementsByClassName("answer")[0];
		let arrowIcon = questionItem.getElementsByClassName("arrowIcon")[0];
		let currentArrowIcon = currentQuestionItem?.getElementsByClassName("arrowIcon")[0];

		if (id == currentQuestion) {
			answer.style.maxHeight = '0';

			arrowIcon.style.animationName = "rotate0";
			arrowIcon.style.animationDuration = "0.2s";

			arrowIcon.style.rotate = "0deg";

			setTimeout(() => {
	            if (answer) {
	                answer.style.display = 'none';
	                setCurrentQuestion('');
	            }
	        }, 200);
		} else if (!currentQuestion) {
			answer.style.display = '';

			arrowIcon.style.animationName = "rotate90";
			arrowIcon.style.animationDuration = "0.2s";

			arrowIcon.style.rotate = "90deg";

			setTimeout(() => {
	            if (answer) {
	                answer.style.maxHeight = '100vh';
	                setCurrentQuestion(id);
	            }
	        }, 10);
		} else {
			currentAnswer.style.maxHeight = '0';

			arrowIcon.style.animationName = "rotate90";
			arrowIcon.style.animationDuration = "0.2s";

			arrowIcon.style.rotate = "90deg";
			
			currentArrowIcon.style.animationName = "rotate0";
			currentArrowIcon.style.animationDuration = "0.2s";

			currentArrowIcon.style.rotate = "0deg";



			setTimeout(() => {
	            if (currentAnswer) {
	                currentAnswer.style.display = 'none';
	            }
	        }, 200);

	        answer.style.display = '';

			setTimeout(() => {
	            if (answer) {
	                answer.style.maxHeight = '100vh';
	                setCurrentQuestion(id);
	            }
	        }, 10);
		}
	}

	return(
		<>
			<section className="md:px-[40px] px-[20px] bg-[#F2DB64] pt-[30px] font-['Lexend_Deca'] rounded-b-[40px]">
				<header>
					<div className="flex items-center justify-between max-w-[1440px] mx-auto">
						<div className="flex w-fit items-center cursor-pointer">
							<svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path stroke-width="1" d="M20.1 10C20.1 6.19952 18.1185 2.8671 15.1467 1.02373C16.1028 0.684404 17.13 0.499999 18.2 0.499999C23.3268 0.499999 27.5 4.74372 27.5 10C27.5 15.2563 23.3268 19.5 18.2 19.5C17.13 19.5 16.1028 19.3156 15.1467 18.9763C18.1185 17.1329 20.1 13.8005 20.1 10ZM7.9 10C7.9 13.8005 9.88147 17.1329 12.8534 18.9763C11.8973 19.3156 10.87 19.5 9.8 19.5C4.67323 19.5 0.5 15.2563 0.5 10C0.499999 4.74372 4.67323 0.5 9.8 0.5C10.87 0.5 11.8972 0.684404 12.8533 1.02373C9.88147 2.8671 7.9 6.19952 7.9 10Z" stroke="#0E071E"/>
							</svg>
							<span className="font-['Lexend_Zetta'] font-semibold text-[24px] ml-[5px] tracking-[-4px]">Haptica</span>
						</div>
						<div className="font-['Lexend'] font-normal text-[14px] tracking-[3px] min-[900px]:block hidden">
							<span className="cursor-pointer hover:underline underline-offset-[5px] decoration-[2px]">WHAT WE DO</span>
							<span className="xl:mx-[100px] cursor-pointer mx-[50px] cursor-pointer hover:underline underline-offset-[5px] decoration-[2px]">OUR WORK</span>
							<span className="cursor-pointer hover:underline underline-offset-[5px] decoration-[2px]">WHY US?</span>
						</div>
						<div className="font-['Lexend'] font-normal text-[14px] tracking-[3px] flex items-center">
							<div className="sm:flex items-center hidden cursor-pointer border-b-solid hover:border-b-black border-b-[2px] border-b-[#F2DB64]">
								<span className="mr-[5px]">CONTACT US</span>
								<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M1 9L9 1" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M1 1H9V9" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								</svg>
							</div>
							<div className="min-[900px]:hidden border-[2px] border-solid p-[0.5px] rounded-[5px] border-black ml-[20px]">
								<svg className="" width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<g id="SVGRepo_bgCarrier" stroke-width="0"/>
									<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>
									<g id="SVGRepo_iconCarrier"> <path d="M5 12H20" stroke="#000000" stroke-width="2" stroke-linecap="round"/> <path d="M5 17H20" stroke="#000000" stroke-width="2" stroke-linecap="round"/> <path d="M5 7H20" stroke="#000000" stroke-width="2" stroke-linecap="round"/> </g>
								</svg>
							</div>
						</div>
					</div>
				</header>
				<div className="pb-[330px] pt-[170px] font-light md:text-[64px] text-[32px] mx-auto text-center">
					Product Development
				</div>
			</section>

			<section className="mx-auto">
				<div className="border-b-[#EEEFF1] border-b-solid border-b-[1px]">
					<div className="md:px-[40px] px-[20px] mt-[-150px]">
						<img className="mx-auto" src={mainImage} />
						<div className="font-['Lexend'] my-[100px] font-normal text-[18px] max-w-[555px] mx-auto leading-[28px]">
							Pretium nunc nulla eu dolor pellentesque. Hendrerit tempor malesuada justo aliquet accumsan nulla arcu dolor. Tortor lorem nec ut vulputate purus quis tellus proin at. Urna diam blandit at sit pellentesque lacinia lectus rhoncus. Turpis egestas venenatis nulla bibendum.
						</div>
					</div>
				</div>
				<div className="md:px-[40px] px-[20px] font-normal text-[16px] font-['Lexend_Deca'] my-[40px]">
					<div className="">
						<span>Brands trust us are more than 500</span>
						<div className="flex items-center lg:justify-between justify-center mt-[50px] flex-wrap gap-[40px]">
							<img src={spendflo} />
							<img src={pepsico} />
							<img src={tatadigital} />
							<img src={facebook} />
							<img src={youtube} />
							<img src={amazon} />
						</div>
					</div>
				</div>
			</section>

			<section className="text-white md:px-[40px] px-[20px] min-[1200px]:py-[250px] py-[100px] font-['Lexend_Deca'] bg-[#191919]">
				<div className="flex items-center min-[1200px]:flex-row flex-col max-w-[1440px] mx-auto">
					<div className="font-light sm:text-[40px] text-[30px] leading-[56px] max-w-[668px] min-[1200px]:text-left text-center">
						Are you a startup brand, well established company, in the India or worldwide? It doesn't matter. We work with a range of clients.
					</div>
					<div className="mx-auto min-[1200px]:mt-[0px] mt-[100px]">
						<div className="w-fit text-[18px] font-['Lexend'] text-[#6D6D6D] max-[1200px]:mx-auto">Our Website Capabilities</div>
						<div className="grid grid-cols-2 mt-[30px] xl:gap-x-[75px] gap-y-[20px]">
							<span className="flex items-center">
								<svg className="min-w-[20px]" width="20" height="20" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M17.6667 8.57144V9.3381C17.6656 11.1351 17.0838 12.8837 16.0078 14.323C14.9318 15.7622 13.4194 16.8152 11.6961 17.3247C9.97286 17.8342 8.13105 17.773 6.44539 17.1503C4.75973 16.5275 3.32055 15.3765 2.34247 13.869C1.36439 12.3615 0.899826 10.5782 1.01806 8.78503C1.1363 6.99191 1.83101 5.28504 2.99857 3.919C4.16613 2.55295 5.74399 1.60092 7.49682 1.20489C9.24966 0.808861 11.0836 0.990051 12.725 1.72144M17.6667 2.67144L9.33334 11.0131L6.83334 8.5131" stroke="#2FD892" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
								</svg>
								<span className="ml-[10px]">Web Design</span>
							</span>
							<span className="flex items-center">
								<svg className="min-w-[20px]" width="20" height="20" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M17.6667 8.57144V9.3381C17.6656 11.1351 17.0838 12.8837 16.0078 14.323C14.9318 15.7622 13.4194 16.8152 11.6961 17.3247C9.97286 17.8342 8.13105 17.773 6.44539 17.1503C4.75973 16.5275 3.32055 15.3765 2.34247 13.869C1.36439 12.3615 0.899826 10.5782 1.01806 8.78503C1.1363 6.99191 1.83101 5.28504 2.99857 3.919C4.16613 2.55295 5.74399 1.60092 7.49682 1.20489C9.24966 0.808861 11.0836 0.990051 12.725 1.72144M17.6667 2.67144L9.33334 11.0131L6.83334 8.5131" stroke="#2FD892" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
								</svg>
								<span className="ml-[10px]">UX Design</span>
							</span>
							<span className="flex items-center">
								<svg className="min-w-[20px]" width="20" height="20" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M17.6667 8.57144V9.3381C17.6656 11.1351 17.0838 12.8837 16.0078 14.323C14.9318 15.7622 13.4194 16.8152 11.6961 17.3247C9.97286 17.8342 8.13105 17.773 6.44539 17.1503C4.75973 16.5275 3.32055 15.3765 2.34247 13.869C1.36439 12.3615 0.899826 10.5782 1.01806 8.78503C1.1363 6.99191 1.83101 5.28504 2.99857 3.919C4.16613 2.55295 5.74399 1.60092 7.49682 1.20489C9.24966 0.808861 11.0836 0.990051 12.725 1.72144M17.6667 2.67144L9.33334 11.0131L6.83334 8.5131" stroke="#2FD892" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
								</svg>
								<span className="ml-[10px]">eCommerce</span>
							</span>
							<span className="flex items-center">
								<svg className="min-w-[20px]" width="20" height="20" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M17.6667 8.57144V9.3381C17.6656 11.1351 17.0838 12.8837 16.0078 14.323C14.9318 15.7622 13.4194 16.8152 11.6961 17.3247C9.97286 17.8342 8.13105 17.773 6.44539 17.1503C4.75973 16.5275 3.32055 15.3765 2.34247 13.869C1.36439 12.3615 0.899826 10.5782 1.01806 8.78503C1.1363 6.99191 1.83101 5.28504 2.99857 3.919C4.16613 2.55295 5.74399 1.60092 7.49682 1.20489C9.24966 0.808861 11.0836 0.990051 12.725 1.72144M17.6667 2.67144L9.33334 11.0131L6.83334 8.5131" stroke="#2FD892" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
								</svg>
								<span className="ml-[10px]">Responsive Design</span>
							</span>
							<span className="flex items-center">
								<svg className="min-w-[20px]" width="20" height="20" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M17.6667 8.57144V9.3381C17.6656 11.1351 17.0838 12.8837 16.0078 14.323C14.9318 15.7622 13.4194 16.8152 11.6961 17.3247C9.97286 17.8342 8.13105 17.773 6.44539 17.1503C4.75973 16.5275 3.32055 15.3765 2.34247 13.869C1.36439 12.3615 0.899826 10.5782 1.01806 8.78503C1.1363 6.99191 1.83101 5.28504 2.99857 3.919C4.16613 2.55295 5.74399 1.60092 7.49682 1.20489C9.24966 0.808861 11.0836 0.990051 12.725 1.72144M17.6667 2.67144L9.33334 11.0131L6.83334 8.5131" stroke="#2FD892" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
								</svg>
								<span className="ml-[10px]">Wireframes</span>
							</span>
							<span className="flex items-center">
								<svg className="min-w-[20px]" width="20" height="20" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M17.6667 8.57144V9.3381C17.6656 11.1351 17.0838 12.8837 16.0078 14.323C14.9318 15.7622 13.4194 16.8152 11.6961 17.3247C9.97286 17.8342 8.13105 17.773 6.44539 17.1503C4.75973 16.5275 3.32055 15.3765 2.34247 13.869C1.36439 12.3615 0.899826 10.5782 1.01806 8.78503C1.1363 6.99191 1.83101 5.28504 2.99857 3.919C4.16613 2.55295 5.74399 1.60092 7.49682 1.20489C9.24966 0.808861 11.0836 0.990051 12.725 1.72144M17.6667 2.67144L9.33334 11.0131L6.83334 8.5131" stroke="#2FD892" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
								</svg>
								<span className="ml-[10px]">Strategy</span>
							</span>
						</div>
					</div>
				</div>
			</section>

			<section className="md:px-[72px] px-[20px] font-['Lexend'] max-w-[1440px] mx-auto">
				<div className="mt-[160px] flex items-center">
					<div className="w-[47%] lg:block hidden">
						<img className="" src={websiteCapabilities} />
					</div>
					<div className="lg:ml-[90px] flex flex-col gap-y-[30px] lg:max-w-[538px] w-[100%] lg:text-left text-center">
						<span className="text-[#7D7C86]">Our Website Capabilities</span>
						<div className="font-['Lexend_Deca'] lg:text-[40px] text-[30px] font-light leading-[48px]">
							We know it’s hard for brands to setup an online experience, and budgets can be tight.
						</div>
						<div className="text-[#7D7C86] font-normal leading-[28px]">
							Magna sit duis netus mauris cursus pellentesque pellentesque imperdiet. Commodo nullam tellus turpis dapibus et lectus egestas vitae. Vestibulum risus dolor enim turpis. Aliquam adipiscing id tristique nec. Non quis id fermentum vitae pulvinar. Semper elit at posuere mauris phasellus. Dignissim posuere faucibus phasellus sit iaculis elementum id ipsum. Enim mattis pellentesque.
						</div>
						<span className="font-normal font-['Lexend_Deca'] bg-[#000000] text-white cursor-pointer py-[16px] px-[24px] w-fit rounded-[28px] max-lg:mx-auto">Schedule a call with our team</span>
					</div>
				</div>
				<div className="mt-[220px] flex items-center justify-end">
					<div className="lg:mr-[90px] flex flex-col gap-[30px] lg:max-w-[538px] w-[100%] lg:text-left text-center">
						<span className="text-[#7D7C86]">Our Website Capabilities</span>
						<div className="font-['Lexend_Deca'] lg:text-[40px] text-[30px] font-light leading-[48px]">
							We know it’s hard for brands to setup an online experience, and budgets can be tight.
						</div>
						<div className="text-[#7D7C86] font-normal leading-[28px]">
							Magna sit duis netus mauris cursus pellentesque pellentesque imperdiet. Commodo nullam tellus turpis dapibus et lectus egestas vitae. Vestibulum risus dolor enim turpis. Aliquam adipiscing id tristique nec. Non quis id fermentum vitae pulvinar. Semper elit at posuere mauris phasellus. Dignissim posuere faucibus phasellus sit iaculis elementum id ipsum. Enim mattis pellentesque.
						</div>
						<span className="font-normal font-['Lexend_Deca'] bg-[#000000] text-white cursor-pointer py-[16px] px-[24px] w-fit rounded-[28px] max-lg:mx-auto">Get Demo for free</span>
					</div>
					<div className="w-[47%] lg:block hidden">
						<img className="ml-auto" src={websiteCapabilities} />
					</div>
				</div>
				<div className="mt-[175px]">
					<div className="font-['Lexend_Deca'] lg:text-[40px] sm:text-[30px] text-[20px] font-light sm:leading-[56px] leading-[40px] text-right">
						We use the latest technologies 
						<br />
						available to create timeless products.
					</div>
				</div>
			</section>

			<section>
				<div className="mt-[85px] flex overflow-hidden gap-[15px] ml-[-73px]">
					<div className="rounded-[32px] bg-[#F2F2F2] min-w-[322px] h-[124px]">
						<img className="grid top-[50%] left-[50%] relative" src={tatadigitalTech} style={{
							transform: "translate(-50%, -50%)"
						}} />
					</div>
					<div className="rounded-[32px] bg-[#F2F2F2] min-w-[322px] h-[124px]">
						<img className="grid top-[50%] left-[50%] relative" src={tatadigitalTech} style={{
							transform: "translate(-50%, -50%)"
						}} />
					</div>
					<div className="rounded-[32px] bg-[#F2F2F2] min-w-[322px] h-[124px]">
						<img className="grid top-[50%] left-[50%] relative" src={tatadigitalTech} style={{
							transform: "translate(-50%, -50%)"
						}} />
					</div>
					<div className="rounded-[32px] bg-[#F2F2F2] min-w-[322px] h-[124px]">
						<img className="grid top-[50%] left-[50%] relative" src={tatadigitalTech} style={{
							transform: "translate(-50%, -50%)"
						}} />
					</div>
					<div className="rounded-[32px] bg-[#F2F2F2] min-w-[322px] h-[124px]">
						<img className="grid top-[50%] left-[50%] relative" src={tatadigitalTech} style={{
							transform: "translate(-50%, -50%)"
						}} />
					</div>
					<div className="rounded-[32px] bg-[#F2F2F2] min-w-[322px] h-[124px]">
						<img className="grid top-[50%] left-[50%] relative" src={tatadigitalTech} style={{
							transform: "translate(-50%, -50%)"
						}} />
					</div>
					<div className="rounded-[32px] bg-[#F2F2F2] min-w-[322px] h-[124px]">
						<img className="grid top-[50%] left-[50%] relative" src={tatadigitalTech} style={{
							transform: "translate(-50%, -50%)"
						}} />
					</div>
					<div className="rounded-[32px] bg-[#F2F2F2] min-w-[322px] h-[124px]">
						<img className="grid top-[50%] left-[50%] relative" src={tatadigitalTech} style={{
							transform: "translate(-50%, -50%)"
						}} />
					</div>
				</div>
			</section>

			<section className="mt-[170px] max-w-[1440px] mx-auto md:px-[40px] px-[20px]">
				<span className="text-[#7D7C86] font-['Lexend'] text-[18px]">What we can help you with</span>
				<div className="mt-[30px] font-['Lexend_Deca'] font-light leading-[48px] md:text-[40px] text-[30px] max-w-[783px]">
					A team of product development experts that can help you design and build a website you’re proud of
				</div>
			</section>

			<section className="mt-[80px] max-w-[1440px] mx-auto">
				<div className="grid min-[1400px]:grid-cols-4 min-[700px]:grid-cols-2 grid-cols-1 font-normal font-['Lexend'] text-left">
					<div className="pl-[40px] pr-[25px] py-[40px] border-[#EEEFF1] border-solid border-[1px]">
						<div className="text-[24px] mb-[150px]">Web Design</div>
						<div className="text-[#7D7C86] text-[18px] leading-[28px] sm:min-w-[282px]">We work closely with you to understand your vision and goals.</div>
					</div>
					<div className="pl-[40px] pr-[25px] py-[40px] border-[#EEEFF1] border-solid border-[1px]">
						<div className="text-[24px] mb-[150px]">eCommerce</div>
						<div className="text-[#7D7C86] text-[18px] leading-[28px] sm:min-w-[282px]">Our streamlined approach helps you launch your product efficiently.</div>
					</div>
					<div className="pl-[40px] pr-[25px] py-[40px] border-[#EEEFF1] border-solid border-[1px]">
						<div className="text-[24px] mb-[150px]">Wireframes</div>
						<div className="text-[#7D7C86] text-[18px] leading-[28px] sm:min-w-[282px]">We build products that can grow alongside your business.</div>
					</div>
					<div className="pl-[40px] pr-[25px] py-[40px] border-[#EEEFF1] border-solid border-[1px]">
						<div className="text-[24px] mb-[150px]">UX Design</div>
						<div className="text-[#7D7C86] text-[18px] leading-[28px] sm:min-w-[282px]">We track key metrics to demonstrate the success of your product and marketing efforts.</div>
					</div>
					<div className="pl-[40px] pr-[25px] py-[40px] border-[#EEEFF1] border-solid border-[1px]">
						<div className="text-[24px] mb-[150px]">Responsive Design</div>
						<div className="text-[#7D7C86] text-[18px] leading-[28px] sm:min-w-[282px]">We track key metrics to demonstrate the success of your product and marketing efforts.</div>
					</div>
					<div className="pl-[40px] pr-[25px] py-[40px] border-[#EEEFF1] border-solid border-[1px]">
						<div className="text-[24px] mb-[150px]">Strategy</div>
						<div className="text-[#7D7C86] text-[18px] leading-[28px] sm:min-w-[282px]">We track key metrics to demonstrate the success of your product and marketing efforts.</div>
					</div>
					<div className="min-[700px]:col-span-2 flex items-end min-[1400px]:pb-[40px] min-[1400px]:ml-auto max-[1400px]:mx-auto max-[1400px]:mt-[50px] min-[1400px]:pr-[40px]">
						<div className="flex min-[500px]:flex-row flex-col items-center mx-auto gap-[40px]">
							<div className="w-fit flex items-center cursor-pointer border-b-solid hover:border-b-black border-b-[2px] border-b-[#ffffff] font-['Lexend_Deca'] font-normal">
								<span className="mr-[5px]">Get Demo for free</span>
								<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M1 9L9 1" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M1 1H9V9" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								</svg>
							</div>
							<div className="font-normal font-['Lexend_Deca'] bg-[#000000] text-white cursor-pointer py-[16px] px-[24px] w-fit rounded-[28px]">
								Get in touch today
							</div>
						</div>
					</div>
				</div>
			</section>

			<section className="mt-[170px] md:px-[40px] px-[20px] mx-auto max-w-[1440px] font-['Lexend_Deca']">
				<div className="text-[40px] font-light">What our happy clients say about us</div> 
				<div className="mt-[80px] rounded-[40px] bg-[#F2DB64] lg:pl-[80px] xl:pr-[117px] lg:pr-[80px] px-[40px] pt-[68px] max-lg:pb-[40px] flex items-center justify-between">
					<div>
						<svg width="44" height="33" viewBox="0 0 44 33" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M11.152 32.128C9.104 32.128 7.26933 31.616 5.648 30.592C4.112 29.568 2.91733 28.16 2.064 26.368C1.21067 24.4907 0.784 22.3147 0.784 19.84C0.784 17.7067 1.12533 15.7013 1.808 13.824C2.49067 11.8613 3.472 10.0693 4.752 8.448C6.11733 6.74133 7.73867 5.20533 9.616 3.84C11.5787 2.38933 13.7973 1.152 16.272 0.127998L19.728 4.73599C16.912 6.18666 14.6507 7.808 12.944 9.6C11.2373 11.392 10.384 13.0987 10.384 14.72C10.384 15.8293 10.6827 16.8107 11.28 17.664C11.8773 18.5173 12.7307 19.4133 13.84 20.352C15.2053 21.376 16.144 22.3573 16.656 23.296C17.2533 24.2347 17.552 25.216 17.552 26.24C17.552 28.032 16.9547 29.4827 15.76 30.592C14.6507 31.616 13.1147 32.128 11.152 32.128ZM34.96 32.128C32.912 32.128 31.0773 31.616 29.456 30.592C27.92 29.568 26.7253 28.16 25.872 26.368C25.0187 24.4907 24.592 22.3147 24.592 19.84C24.592 17.7067 24.9333 15.7013 25.616 13.824C26.2987 11.8613 27.28 10.0693 28.56 8.448C29.9253 6.74133 31.5467 5.20533 33.424 3.84C35.3867 2.38933 37.6053 1.152 40.08 0.127998L43.536 4.73599C40.72 6.18666 38.4587 7.808 36.752 9.6C35.0453 11.392 34.192 13.0987 34.192 14.72C34.192 15.8293 34.4907 16.8107 35.088 17.664C35.6853 18.5173 36.5387 19.4133 37.648 20.352C39.0133 21.376 39.952 22.3573 40.464 23.296C41.0613 24.2347 41.36 25.216 41.36 26.24C41.36 28.032 40.7627 29.4827 39.568 30.592C38.4587 31.616 36.9227 32.128 34.96 32.128Z" fill="black"/>
						</svg>
						<div className="font-light xl:text-[40px] sm:text-[30px] text-[25px] lg:max-w-[638px] mt-[40px] sm:leading-[48px] leading-[40px]">
							Haptica went above and beyond to make sure we got something we were happy with
						</div>
						<div className="mt-[40px] font-['Lexend'] text-[20px]">Johnson Root</div>
						<div className="font-['Lexend'] font-light">Creative Director, Black Wheel</div>
					</div>
					<div className="lg:block hidden ml-[20px]">
						<img src={johnsonRoot} />
					</div>
				</div>
				<div className="flex gap-[8px] mt-[25px] justify-end">
					<div className="bg-black py-[16px] px-[24px] w-fit rounded-[28px]">
						<svg className="" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M12.3136 6.65685H0.999884" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M6.65674 1L0.999884 6.65685L6.65674 12.3137" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
					</div>
					<div className="bg-black py-[16px] px-[24px] w-fit rounded-[28px]">
						<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M1.31336 6.65685H12.6271" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M6.97021 1L12.6271 6.65685L6.97021 12.3137" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
					</div>
				</div>
				<div className="mt-[150px] font-['Lexend_Deca'] sm:text-[40px] text-[30px] font-light leading-[56px] sm:text-right text-center">
					Our favourite
					<br className="max-sm:hidden" /> Recent Developed Products
				</div>
				<div className="mt-[100px] grid lg:grid-cols-6 sm:grid-cols-4 grid-cols-2 gap-[25px] flex justify-center">
					<div className="col-span-2 rounded-[40px] bg-black sm:pl-[75px] pl-[40px] pt-[40px]">
						<svg className="ml-auto mr-[40px]" width="12" height="12" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M1 9L9 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M1 1H9V9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
						<div className="text-[#F7D772] font-['Leckerli_One'] text-[64px] font-normal">
							Config
						</div>
						<img src={config} className="mt-[40px] ml-auto" />
					</div>
					<div className="col-span-2 rounded-[40px] bg-[#E08686] sm:pl-[75px] pl-[40px] pt-[40px]">
						<svg className="ml-auto mr-[40px]" width="12" height="12" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M1 9L9 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M1 1H9V9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
						<div className="text-[#F7D772] font-['Leckerli_One'] text-[64px] font-normal">
							Config
						</div>
						<img src={config} className="mt-[40px] ml-auto" />
					</div>
					<div className="col-span-2 max-lg:col-start-2 max-sm:col-start-1 rounded-[40px] bg-[#FFA4F0] sm:pl-[75px] pl-[40px] pt-[40px]">
						<svg className="ml-auto mr-[40px]" width="12" height="12" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M1 9L9 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M1 1H9V9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
						<div className="text-[#FFFBEF] font-['Leckerli_One'] text-[64px] font-normal">
							Config
						</div>
						<img src={config} className="mt-[40px] ml-auto" />
					</div>
				</div>
				<div className="mt-[160px] flex xl:flex-row flex-col gap-[30px] justify-between">
					<div className="font-['Lexend_Deca'] font-light text-[40px] leading-[48px] xl:max-w-[437px] max-w-full mx-auto md:text-left text-center">The answers to your questions.</div>
					<div className="min-[850px]:min-w-[783px] min-w-full font-['Lexend_Deca'] font-normal grid gap-[10px] max-xl:mx-auto">
						<div id="question1" className="bg-[#F2F2F2] rounded-[32px] p-[30px] cursor-pointer overflow-hidden" onClick={() => onQuestionItemClicked("question1")}>
							<div className="text-[20px] flex justify-between items-center">
								<span>How long does it take to build a website?</span>
								<div className="p-[12px] rounded-[50%] border-solid border-[1px] border-[#989898]">
									<svg className="arrowIcon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" style={{
										rotate: "90deg"
									}}>
										<path d="M1.31336 6.65685H12.6271" stroke="#989898" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
										<path d="M6.97021 1L12.6271 6.65685L6.97021 12.3137" stroke="#989898" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
									</svg>
								</div>
							</div>
							<div id="" className="answer text-[#7D7C86]" style={{
								maxHeight: '100vh'
							}}>
								<div className="my-[25px]">Timelines depend on the spec of the website project, but here are some guidelines...</div>
								<ul className="list-disc leading-[28px] ml-[30px]">
									<li>Shopify projects usually take around four weeks.</li>
									<li>Craft CMS projects usually take a minimum of five weeks.</li>
									<li>Craft Commerce projects usually take a minimum of eight weeks.</li>
								</ul>
							</div>
						</div>
						<div id="question2" className="bg-[#F2F2F2] rounded-[32px] p-[30px] cursor-pointer overflow-hidden" onClick={() => onQuestionItemClicked("question2")}>
							<div className="text-[20px] flex justify-between items-center">
								<span>How long does it take to build a website?</span>
								<div className="p-[12px] rounded-[50%] border-solid border-[1px] border-[#989898]">
									<svg className="arrowIcon" transform="rotate(0 0 0)" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M1.31336 6.65685H12.6271" stroke="#989898" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
										<path d="M6.97021 1L12.6271 6.65685L6.97021 12.3137" stroke="#989898" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
									</svg>
								</div>
							</div>
							<div id="" className="answer text-[#7D7C86]" style={{
								display: 'none'
							}}>
								<div className="my-[25px]">Timelines depend on the spec of the website project, but here are some guidelines...</div>
								<ul className="list-disc leading-[28px] ml-[30px]">
									<li>Shopify projects usually take around four weeks.</li>
									<li>Craft CMS projects usually take a minimum of five weeks.</li>
									<li>Craft Commerce projects usually take a minimum of eight weeks.</li>
								</ul>
							</div>
						</div>
						<div id="question3" className="bg-[#F2F2F2] rounded-[32px] p-[30px] cursor-pointer overflow-hidden" onClick={() => onQuestionItemClicked("question3")}>
							<div className="text-[20px] flex justify-between items-center">
								<span>How long does it take to build a website?</span>
								<div className="p-[12px] rounded-[50%] border-solid border-[1px] border-[#989898]">
									<svg className="arrowIcon" transform="rotate(0 0 0)" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M1.31336 6.65685H12.6271" stroke="#989898" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
										<path d="M6.97021 1L12.6271 6.65685L6.97021 12.3137" stroke="#989898" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
									</svg>
								</div>
							</div>
							<div id="" className="answer text-[#7D7C86]" style={{
								display: 'none'
							}}>
								<div className="my-[25px]">Timelines depend on the spec of the website project, but here are some guidelines...</div>
								<ul className="list-disc leading-[28px] ml-[30px]">
									<li>Shopify projects usually take around four weeks.</li>
									<li>Craft CMS projects usually take a minimum of five weeks.</li>
									<li>Craft Commerce projects usually take a minimum of eight weeks.</li>
								</ul>
							</div>
						</div>
						<div id="question4" className="bg-[#F2F2F2] rounded-[32px] p-[30px] cursor-pointer overflow-hidden" onClick={() => onQuestionItemClicked("question4")}>
							<div className="text-[20px] flex justify-between items-center">
								<span>How long does it take to build a website?</span>
								<div className="p-[12px] rounded-[50%] border-solid border-[1px] border-[#989898]">
									<svg className="arrowIcon" transform="rotate(0 0 0)" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M1.31336 6.65685H12.6271" stroke="#989898" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
										<path d="M6.97021 1L12.6271 6.65685L6.97021 12.3137" stroke="#989898" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
									</svg>
								</div>
							</div>
							<div id="" className="answer text-[#7D7C86]" style={{
								display: 'none'
							}}>
								<div className="my-[25px]">Timelines depend on the spec of the website project, but here are some guidelines...</div>
								<ul className="list-disc leading-[28px] ml-[30px]">
									<li>Shopify projects usually take around four weeks.</li>
									<li>Craft CMS projects usually take a minimum of five weeks.</li>
									<li>Craft Commerce projects usually take a minimum of eight weeks.</li>
								</ul>
							</div>
						</div>
						<div id="question5" className="bg-[#F2F2F2] rounded-[32px] p-[30px] cursor-pointer overflow-hidden" onClick={() => onQuestionItemClicked("question5")}>
							<div className="text-[20px] flex justify-between items-center">
								<span>How long does it take to build a website?</span>
								<div className="p-[12px] rounded-[50%] border-solid border-[1px] border-[#989898]">
									<svg className="arrowIcon" transform="rotate(0 0 0)" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M1.31336 6.65685H12.6271" stroke="#989898" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
										<path d="M6.97021 1L12.6271 6.65685L6.97021 12.3137" stroke="#989898" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
									</svg>
								</div>
							</div>
							<div id="" className="answer text-[#7D7C86]" style={{
								display: 'none'
							}}>
								<div className="my-[25px]">Timelines depend on the spec of the website project, but here are some guidelines...</div>
								<ul className="list-disc leading-[28px] ml-[30px]">
									<li>Shopify projects usually take around four weeks.</li>
									<li>Craft CMS projects usually take a minimum of five weeks.</li>
									<li>Craft Commerce projects usually take a minimum of eight weeks.</li>
								</ul>
							</div>
						</div>
						<div id="question6" className="bg-[#F2F2F2] rounded-[32px] p-[30px] cursor-pointer overflow-hidden" onClick={() => onQuestionItemClicked("question6")}>
							<div className="text-[20px] flex justify-between items-center">
								<span>How long does it take to build a website?</span>
								<div className="p-[12px] rounded-[50%] border-solid border-[1px] border-[#989898]">
									<svg className="arrowIcon" transform="rotate(0 0 0)" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M1.31336 6.65685H12.6271" stroke="#989898" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
										<path d="M6.97021 1L12.6271 6.65685L6.97021 12.3137" stroke="#989898" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
									</svg>
								</div>
							</div>
							<div id="" className="answer text-[#7D7C86]" style={{
								display: 'none'
							}}>
								<div className="my-[25px]">Timelines depend on the spec of the website project, but here are some guidelines...</div>
								<ul className="list-disc leading-[28px] ml-[30px]">
									<li>Shopify projects usually take around four weeks.</li>
									<li>Craft CMS projects usually take a minimum of five weeks.</li>
									<li>Craft Commerce projects usually take a minimum of eight weeks.</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div className="mt-[150px] max-w-[1128px] bg-black mx-auto rounded-[40px] text-white font-['Lexend_Deca'] pt-[90px] pb-[70px] min-[900px]:px-[80px] sm:px-[40px] px-[20px]">
					<div className="lg:text-[40px] sm:text-[35px] text-[25px] font-light leading-[48px]">
						Get a <span className="highlightYellow">stunning product</span> developed 
						<br className="md:block hidden" />
						<span className="md:hidden">&nbsp;</span>
						and online within the next 10 days.
					</div>
					<div className="mt-[125px] font-['Lexend_Deca'] bg-[#F2DB64] rounded-[28px] w-fit text-black py-[16px] px-[24px] cursor-pointer max-sm:mx-auto">
						Get an instant quote
					</div>
				</div>
			</section>

			<section>
				<div className="bg-[#F2DB64] mt-[-86px] rounded-t-[40px] z-[-1] relative">
					<div className="max-w-[1440px] mx-auto sm:px-[40px] px-[20px] pt-[190px] pb-[150px] flex lg:flex-row flex-col justify-between items-start gap-[40px]">
						<div className="flex w-fit items-center cursor-pointer max-lg:mx-auto">
							<svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path stroke-width="1" d="M20.1 10C20.1 6.19952 18.1185 2.8671 15.1467 1.02373C16.1028 0.684404 17.13 0.499999 18.2 0.499999C23.3268 0.499999 27.5 4.74372 27.5 10C27.5 15.2563 23.3268 19.5 18.2 19.5C17.13 19.5 16.1028 19.3156 15.1467 18.9763C18.1185 17.1329 20.1 13.8005 20.1 10ZM7.9 10C7.9 13.8005 9.88147 17.1329 12.8534 18.9763C11.8973 19.3156 10.87 19.5 9.8 19.5C4.67323 19.5 0.5 15.2563 0.5 10C0.499999 4.74372 4.67323 0.5 9.8 0.5C10.87 0.5 11.8972 0.684404 12.8533 1.02373C9.88147 2.8671 7.9 6.19952 7.9 10Z" stroke="#0E071E"/>
							</svg>
							<span className="font-['Lexend_Zetta'] font-semibold text-[24px] ml-[5px] tracking-[-4px]">Haptica</span>
						</div>
						<div className="grid sm:grid-cols-3 grid-cols-2 gap-x-[50px] gap-y-[20px] tracking-[3px] text-[10px] text-left pt-[10px] mx-auto font-normal">
							<span className="cursor-pointer">WHAT WE DO</span>
							<span className="cursor-pointer">OUR WORK</span>
							<span className="cursor-pointer">WHY US?</span>
							<span className="cursor-pointer">BLOG</span>
							<span className="cursor-pointer">CUSTOMER STORIES</span>
							<span className="cursor-pointer">IN NEWS</span>
						</div>
						<div className="xl:flex hidden w-fit items-center cursor-pointer text-[#F2DB64]">
							<svg width="28" height="20" viewBox="0 0 28 20" fill="#F2DB64" xmlns="http://www.w3.org/2000/svg">
								<path stroke-width="1" d="M20.1 10C20.1 6.19952 18.1185 2.8671 15.1467 1.02373C16.1028 0.684404 17.13 0.499999 18.2 0.499999C23.3268 0.499999 27.5 4.74372 27.5 10C27.5 15.2563 23.3268 19.5 18.2 19.5C17.13 19.5 16.1028 19.3156 15.1467 18.9763C18.1185 17.1329 20.1 13.8005 20.1 10ZM7.9 10C7.9 13.8005 9.88147 17.1329 12.8534 18.9763C11.8973 19.3156 10.87 19.5 9.8 19.5C4.67323 19.5 0.5 15.2563 0.5 10C0.499999 4.74372 4.67323 0.5 9.8 0.5C10.87 0.5 11.8972 0.684404 12.8533 1.02373C9.88147 2.8671 7.9 6.19952 7.9 10Z" stroke="#F2DB64"/>
							</svg>
							<span className="font-['Lexend_Zetta'] font-semibold text-[24px] ml-[5px] tracking-[-4px]">Haptica</span>
						</div>
					</div>
				</div>
			</section>
		</>
	)
}

export default Service;















